import axios from '@/util/basehttp';
import qs from 'qs';


const baseFile = {

  imgUpLoad(fileobj) {
    let param = new FormData()
    param.append('file', fileobj.file)
    return axios({
      method: 'post',
      url: '/file/base/uploadImgFile',
      headers: {'Content-Type': 'multipart/form-data'},
      data: param
    })
  },

  uploadFile(fileobj) {
    let param = new FormData()
    param.append('file', fileobj.file)
    return axios({
      method: 'post',
      url: '/file/base/uploadFile',
      headers: {'Content-Type': 'multipart/form-data;charset=utf-8'},
      data: param
    })
  },

  uploadVideoFile(fileobj) {
    let param = new FormData()
    param.append('file', fileobj.file)
    return axios({
      method: 'post',
      url: '/file/base/uploadVideoFile',
      headers: {'Content-Type': 'multipart/form-data'},
      data: param
    })
  }
}
export default baseFile;




// WEBPACK FOOTER //
// ./src/api/base/file/file.js